export const isNull = (value: unknown): value is null => {
	return value === null;
};

export const isUndefined = (value: unknown): value is undefined => {
	return typeof value === 'undefined';
};

export const isNullOrUndefined = (value: unknown): value is null | undefined => {
	return isNull(value) || isUndefined(value);
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
	return Object.prototype.toString.call(value).slice(8, -1).toLowerCase() === 'object';
};
